(function() {
  const root = document.getElementById('volume-pricing');
  if (!root) return;

  const moneyFormat = root.dataset.moneyFormat || "${{amount}}";
  const qtyInput = document.querySelector('input[name="quantity"]') || document.getElementById('Quantity') || document.querySelector('.quantity__input');
  const unitPriceEl = document.getElementById('vp-unit-price');
  const savingsEl   = document.getElementById('vp-savings');
  const totalEl     = document.getElementById('vp-total');
  const savingsRow  = root.querySelector('.vp-savings');

  let tiers = [];
  try { tiers = JSON.parse(root.dataset.tiers || "[]"); } catch(e) { tiers = []; }

  function formatMoney(cents) {
    // usa il formatter nativo di Shopify se disponibile
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
    return (cents/100).toLocaleString(undefined, { style: 'currency', currency: document.documentElement.lang === 'it' ? 'EUR' : 'EUR' });
  }

  function getVariantPriceCents() {
    // prova a leggere da dataset aggiornato dal tema Trade (su cambio variante)
    if (root.dataset.variantPrice) return parseInt(root.dataset.variantPrice, 10);
    // fallback: cerca elemento prezzo del tema
    const priceNode = document.querySelector('[data-product-price] [data-regular-price], .price-item--regular');
    if (priceNode && priceNode.dataset.price) return parseInt(priceNode.dataset.price, 10);
    // ultimo fallback: dataset iniziale
    return parseInt(root.getAttribute('data-variant-price'), 10);
  }

  function pickTier(qty) {
    // ritorna la tier con min più alta che non supera qty
    let best = null;
    tiers.forEach(t => { if (qty >= (t.min || 0)) best = t; });
    return best;
  }

  function applyDiscount(baseCents, tier) {
    if (!tier) return { unitCents: baseCents, discountPerUnit: 0 };
    if (tier.discount_type === 'percent') {
      const unit = Math.round(baseCents * (1 - (tier.value/100)));
      return { unitCents: unit, discountPerUnit: baseCents - unit };
    }
    if (tier.discount_type === 'amount_off_cents') {
      const unit = Math.max(0, baseCents - parseInt(tier.value, 10));
      return { unitCents: unit, discountPerUnit: baseCents - unit };
    }
    if (tier.discount_type === 'unit_price_cents') {
      const unit = parseInt(tier.value, 10);
      return { unitCents: unit, discountPerUnit: Math.max(0, baseCents - unit) };
    }
    return { unitCents: baseCents, discountPerUnit: 0 };
  }

  function render() {
    const qty = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : "1", 10));
    const base = getVariantPriceCents();
    const tier = pickTier(qty);
    const { unitCents, discountPerUnit } = applyDiscount(base, tier);

    unitPriceEl.textContent = formatMoney(unitCents);
    totalEl.textContent     = formatMoney(unitCents * qty);

    if (discountPerUnit > 0) {
      savingsRow.hidden = false;
      const totalSave = discountPerUnit * qty;
      savingsEl.textContent = `${formatMoney(totalSave)} (${formatMoney(discountPerUnit)}/pz)`;
    } else {
      savingsRow.hidden = true;
      savingsEl.textContent = "";
    }
  }

  // ascolta cambi quantità
  if (qtyInput) {
    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('change', render);
  }

  // ascolta cambi variante del tema Trade (spesso dispatcha 'variant:change' o aggiorna dati prezzo)
  document.addEventListener('variant:change', (e) => {
    if (e && e.detail && e.detail.variant && typeof e.detail.variant.price === 'number') {
      root.dataset.variantPrice = String(e.detail.variant.price);
      render();
    } else {
      // fallback: re-render dopo piccolo delay
      setTimeout(render, 50);
    }
  });

  // primo render
  render();
})();
